import { render, staticRenderFns } from "./realTtimeorderMian.vue?vue&type=template&id=079c7371&"
import script from "./realTtimeorderMian.vue?vue&type=script&lang=js&"
export * from "./realTtimeorderMian.vue?vue&type=script&lang=js&"
import style0 from "./realTtimeorderMian.vue?vue&type=style&index=0&id=079c7371&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports